import { View, StyleSheet, Platform } from 'react-native';
import { Text, Surface, List } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import BaseContainer from '@/components/BaseContainer';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { Color } from '@/GlobalStyles';
import { usePatientForm } from '@/contexts/PatientFormContext';

export default function SuccessScreen() {
  const { t } = useTranslation();
  const { patientName } = usePatientForm();

  return (
    <BaseContainer>
      <View style={styles.container}>
        <Surface style={styles.surface} elevation={2}>
          <View style={[styles.iconContainer, { backgroundColor: '#4CAF50' + '20' }]}>
            <Icon name="check-circle" size={64} color="#4CAF50" />
          </View>

          <Text style={styles.title}>{t('patient.formSentSuccess')}</Text>

          <Text style={styles.message}>
            {t('patient.thankYouFull', { name: patientName })}
          </Text>

          <View style={styles.infoContainer}>
            <Text style={styles.infoTitle}>{t('patient.nextSteps')}</Text>

            <View style={styles.stepItem}>
              <Icon name="chart-line" size={24} color={Color.MainBleu} />
              <View style={styles.stepContent}>
                <Text style={styles.stepTitle}>{t('patient.dataAnalysis')}</Text>
                <Text style={styles.stepDescription}>{t('patient.dataAnalysisDesc')}</Text>
              </View>
            </View>

            <View style={styles.stepItem}>
              <Icon name="eye" size={24} color={Color.MainBleu} />
              <View style={styles.stepContent}>
                <Text style={styles.stepTitle}>{t('patient.implantChoice')}</Text>
                <Text style={styles.stepDescription}>{t('patient.implantChoiceDesc')}</Text>
              </View>
            </View>

            <View style={styles.stepItem}>
              <Icon name="phone" size={24} color={Color.MainBleu} />
              <View style={styles.stepContent}>
                <Text style={styles.stepTitle}>{t('patient.contactYou')}</Text>
                <Text style={styles.stepDescription}>{t('patient.contactYouDesc')}</Text>
              </View>
            </View>
          </View>

          <View style={styles.footerMessage}>
            <Icon name="information" size={20} color={Color.MainBleu} />
            <Text style={styles.footerText}>
              {t('patient.canCloseWindow')}
            </Text>
          </View>
        </Surface>
      </View>
    </BaseContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  surface: {
    padding: 32,
    borderRadius: 12,
    backgroundColor: 'white',
    alignItems: 'center',
    width: '100%',
    maxWidth: 600,
  },
  iconContainer: {
    width: 100,
    height: 100,
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  title: {
    fontSize: 28,
    fontWeight: '700',
    marginBottom: 16,
    color: Color.MainNoir,
    textAlign: 'center',
  },
  message: {
    fontSize: 18,
    color: Color.MainGris,
    textAlign: 'center',
    marginBottom: 32,
    lineHeight: 28,
  },
  infoContainer: {
    width: '100%',
    marginBottom: 24,
  },
  infoTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: Color.MainNoir,
    marginBottom: 16,
    textAlign: 'center',
  },
  stepItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 20,
    paddingHorizontal: 8,
  },
  stepContent: {
    flex: 1,
    marginLeft: 12,
  },
  stepTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: Color.MainNoir,
    marginBottom: 4,
  },
  stepDescription: {
    fontSize: 14,
    color: Color.MainGris,
    lineHeight: 20,
  },
  footerMessage: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#E3F2FD',
    padding: 16,
    borderRadius: 8,
    width: '100%',
    gap: 12,
  },
  footerText: {
    flex: 1,
    fontSize: 14,
    color: Color.MainBleu,
    fontWeight: '500',
  },
});
